import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import validators from '../../utils/validators';
import Overlay from '../../forms/_common/Overlay';
import FormErrors from '../../forms/_common/FormErrors';
import RequestError from '../../forms/_common/RequestError';
import ErrorMessage from '../../forms/_common/ErrorMessage';
import SuccessMessage from '../../forms/_common/SuccessMessage';
import DialogTemplate from '../../dialogs_common/DialogTemplate';
import Form from './Form';
import { useQueryMutation } from '../../../hooks/@lore/query-connect';
import { useUser } from '@lore/auth';

UpdateUserOrganizationDialog.propTypes = {
  job: PropTypes.object.isRequired
};

export default function UpdateUserOrganizationDialog(props) {
  const { job, onCancel } = props;

  const user = useUser();

  const [data, setData] = useState({
    title: job.data.title
  });

  const [showErrors, setShowErrors] = useState(false);

  const mutation = useQueryMutation('job.update', job);
  const { saving, success, error, request } = mutation;

  useEffect(() => {
    if (success) {
      props.onCancel();
      props.onSubmit && props.onSubmit(request);
    }
  }, [success]);

  function onSubmit() {
    mutation.mutate(data);
  }

  return (
    <DialogTemplate className="w-96">
      <Overlay isVisible={saving}>
        <FormErrors data={data} validators={{
          title: [validators.isRequired]
        }}>
          {({ errors, hasError }) => (
            <Form
              user={user}
              data={data}
              errors={errors}
              showErrors={showErrors}
              onChange={(name, value) => {
                setData(_.merge({}, data, {
                  [name]: value
                }));
              }}
              onChangeMultiple={(values) => {
                setData(_.merge({}, data, values));
              }}
              onSubmit={() => hasError ? setShowErrors(true) : onSubmit()}
              onCancel={onCancel}
              alert={error ? (
                <RequestError request={request} />
              ) : showErrors ? (
                <ErrorMessage>
                  Please fill in all required fields.
                </ErrorMessage>
              ) : (false && success) ? (
                <SuccessMessage>
                  Contact information updated.
                </SuccessMessage>
              ) : null}
            />
          )}
        </FormErrors>
      </Overlay>
    </DialogTemplate>
  );
};
